export const appName = "JOYSTICK"

export const appSlogan = "PLAY NOW WIN LATER"

export const appDescription = "JOYSTICK is a next-generation gaming platform built around skill, creativity, and competition."

export const dashboardURL = process.env.REACT_APP_WEB_DASHBOARD_ROOT_URL

export const webApiRootURL = process.env.REACT_APP_WEB_API_ROOT_URL